export enum AutomaticBankPcgEntryModeType {
  saleEngagement = 'sale_engagement',
  purchaseEngagement = 'purchase_engagement'
}
